import { storage } from './storage';

export function getStorage(key: string) {
    return storage().get(key);
}
